<div class="main_body">
  <div class="breadcrumb">
    <ol class="breadcrumb__list">
      <li class="breadcrumb__item">
        <button
          mat-icon-button
          class="breadcrumb__btn--user"
          [routerLink]="userListLink()"
          [attr.aria-label]="i18n.breadcrumb.home">
          <mat-icon class="breadcrumb__icon--admin-home">home</mat-icon>
        </button>
      </li>
      <li class="breadcrumb__item">{{ i18n.breadcrumb.tomassSummary }}</li>
    </ol>
  </div>

  @if (vm$ | async; as state) {
    <div class="contents contents--tomass-summary">
      <div class="tomass-summary-shell">
        <section class="tomass-summary-head">
          <div class="tomass-summary-head__header">
            <app-page-header
              [title]="i18n.pageHeader.title"
              [subtitle]="i18n.pageHeader.description"
              icon="tomass">
            </app-page-header>
          </div>
          <div class="tomass-summary-head__actions">
            <button
              mat-stroked-button
              type="button"
              class="tomass-summary-head__pdf-btn"
              (click)="onPrint()"
              [disabled]="isPdfDisabled(state)"
              [attr.aria-label]="i18n.toolbar.pdfOutput"
              [matTooltip]="i18n.toolbar.pdfOutput">
              <mat-icon>picture_as_pdf</mat-icon>
              <span>{{ i18n.toolbar.pdfOutput }}</span>
            </button>
          </div>
        </section>

        <!-- Toolbar / Filters -->
        <section class="tomass-summary-toolbar">
          <div class="tomass-summary-toolbar__filters">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@home.tomassSummary.label.startDate">開始日</mat-label>
              <input matInput [matDatepicker]="startPicker" [value]="state.filters.startDate"
                (dateChange)="onStartDateChanged($event.value)" />
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label i18n="@@home.tomassSummary.label.endDate">終了日</mat-label>
              <input matInput [matDatepicker]="endPicker" [value]="state.filters.endDate"
                (dateChange)="onEndDateChanged($event.value)" />
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ i18n.toolbar.account }}</mat-label>
              <mat-select [value]="state.filters.selectedUserIds" multiple
                (selectionChange)="onAccountsChanged($event.value)"
                panelClass="tomass-account-select-panel">
                <mat-select-trigger>
                  {{ selectedAccountsTriggerLabel(state.filters.selectedUserIds, state.userOptions) }}
                </mat-select-trigger>
                <div class="tomass-account-select-actions">
                  <button mat-button (click)="onSelectAllAccounts(state.userOptions); $event.stopPropagation()" i18n>全て選択</button>
                  <button mat-button (click)="onDeselectAllAccounts(); $event.stopPropagation()" i18n>全て解除</button>
                </div>
                <mat-divider></mat-divider>
                @for (option of state.userOptions; track option.userId) {
                  <mat-option [value]="option.userId">
                    <div class="tomass-account-option">
                      <mat-icon class="tomass-account-option__check">
                        {{ isAccountSelected(option.userId, state.filters.selectedUserIds) ? 'check_box' : 'check_box_outline_blank' }}
                      </mat-icon>
                      <span class="tomass-account-option__label">
                        {{ formatAccountOptionLabel(option) }}
                      </span>
                    </div>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="tomass-summary-toolbar__actions">
            <button mat-flat-button color="primary" (click)="onAggregate()" [disabled]="isAggregateDisabled(state)">
              <span class="tomass-toolbar__aggregate-content">
                @if (state.status === 'loading') {
                  <mat-progress-spinner class="tomass-toolbar__spinner" mode="indeterminate" diameter="16" strokeWidth="3"></mat-progress-spinner>
                } @else {
                  <mat-icon class="tomass-toolbar__icon">bar_chart</mat-icon>
                }
                <span class="tomass-toolbar__label">{{ i18n.toolbar.aggregate }}</span>
              </span>
            </button>
            <button mat-stroked-button (click)="onResetDateRange()">{{ i18n.toolbar.resetPeriod }}</button>
          </div>
        </section>

        @if (state.errorMessage) {
          <div class="tomass-summary-error">{{ state.errorMessage }}</div>
        }

        @if (isPreAggregate(state)) {
          <section class="tomass-summary-guide" i18n="@@home.tomassSummary.guide.setConditions">
            条件を設定して集計してください。
          </section>
        } @else {
          <!-- Summary + Donut Charts (4-column) -->
          <section class="tomass-donut-grid tomass-donut-grid--4col">
            <mat-card class="tomass-chart-card tomass-summary-metrics-card">
              <mat-card-header class="tomass-summary-metrics-card__header">
                <mat-card-title i18n="@@home.tomassSummary.kpi.summaryCardTitle">集計サマリー</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                @if (state.status === 'loading') {
                  <div class="tomass-summary-loading" role="status" aria-live="polite" aria-busy="true">
                    @for (_ of [1, 2, 3, 4, 5, 6]; track $index) {
                      <div class="tomass-summary-loading__row">
                        <div class="tomass-skeleton tomass-summary-loading__label"></div>
                        <div class="tomass-skeleton tomass-summary-loading__value"></div>
                      </div>
                    }
                    <span class="visually-hidden">Loading...</span>
                  </div>
                } @else {
                  <div class="tomass-summary-metrics-card__scroll">
                    <dl class="tomass-summary-metrics">
                      <div class="tomass-summary-metrics__row">
                        <dt>{{ i18n.kpi.records }}</dt>
                        <dd>{{ state.kpi.recordCount | number }}{{ i18n.kpi.unit.count }}</dd>
                      </div>
                      <div class="tomass-summary-metrics__row tomass-summary-metrics__row--period">
                        <dt>{{ i18n.kpi.aggregationPeriod }}</dt>
                        <dd class="tomass-summary-metrics__period">
                          <span class="tomass-summary-metrics__period-date">{{ vm.formatDateLabel(state.filters.startDate) }}</span>
                          <span class="tomass-summary-metrics__period-separator">〜</span>
                          <span class="tomass-summary-metrics__period-date">{{ vm.formatDateLabel(state.filters.endDate) }}</span>
                        </dd>
                      </div>
                      <div class="tomass-summary-metrics__row">
                        <dt>{{ i18n.kpi.accounts }}</dt>
                        <dd>{{ state.kpi.userCount | number }}{{ i18n.kpi.unit.items }}</dd>
                      </div>
                      <div class="tomass-summary-metrics__row">
                        <dt>{{ i18n.kpi.avgAgeGroup }}</dt>
                        <dd>{{ state.kpi.avgAgeGroup ?? '-' }}</dd>
                      </div>
                      <div class="tomass-summary-metrics__row">
                        <dt>{{ i18n.kpi.avgPst }}</dt>
                        <dd>
                          @if (state.kpi.avgPst !== null) {
                            {{ state.kpi.avgPst | number:'1.2-2' }}{{ i18n.kpi.unit.seconds }}
                          } @else {
                            -
                          }
                        </dd>
                      </div>
                      <div class="tomass-summary-metrics__row">
                        <dt>{{ i18n.kpi.avgGpst }}</dt>
                        <dd>
                          @if (state.kpi.avgGpst !== null) {
                            {{ state.kpi.avgGpst | number:'1.2-2' }}{{ i18n.kpi.unit.seconds }}
                          } @else {
                            -
                          }
                        </dd>
                      </div>
                    </dl>
                  </div>
                }
              </mat-card-content>
            </mat-card>

            <!-- Cracker Ratio -->
            <mat-card class="tomass-chart-card">
              <mat-card-header class="tomass-chart-card__header">
                <mat-card-title>{{ i18n.chart.crackerRatio }}</mat-card-title>
                <mat-card-subtitle>{{ state.kpi.recordCount }}{{ i18n.kpi.unit.count }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                @if (state.status === 'loading') {
                  <div class="tomass-chart-loading" role="status" aria-live="polite" aria-busy="true">
                    <div class="tomass-skeleton tomass-chart-loading__visual"></div>
                    <div class="tomass-skeleton tomass-chart-loading__line tomass-chart-loading__line--lg"></div>
                    <div class="tomass-skeleton tomass-chart-loading__line"></div>
                    <span class="visually-hidden">Loading...</span>
                  </div>
                } @else if (state.kpi.recordCount > 0) {
                  <div class="tomass-chart-with-legend">
                    <div echarts [options]="state.crackerRatioOption" [autoResize]="true" class="tomass-chart tomass-chart--donut"></div>
                    <ul class="tomass-legend">
                      @for (item of visibleLegendItems(state.crackerRatioLegend, 'cracker'); track item.label) {
                        <li class="tomass-legend__item">
                          <span class="tomass-legend__dot" [style.background]="item.color"></span>
                          <span class="tomass-legend__label">{{ item.label }}</span>
                          <span class="tomass-legend__count">{{ item.count }}{{ i18n.kpi.unit.count }}</span>
                          <span class="tomass-legend__pct">({{ item.percentage }}%)</span>
                        </li>
                      }
                    </ul>
                    @if (hiddenLegendCount(state.crackerRatioLegend) > 0) {
                      <button class="tomass-legend__toggle" (click)="toggleLegend('cracker')">
                        @if (isLegendExpanded('cracker')) {
                          <mat-icon>expand_less</mat-icon><span i18n>閉じる</span>
                        } @else {
                          <mat-icon>expand_more</mat-icon><span i18n>他{{ hiddenLegendCount(state.crackerRatioLegend) }}件を表示</span>
                        }
                      </button>
                    }
                  </div>
                } @else {
                  <div class="tomass-chart-empty">{{ i18n.chart.noData }}</div>
                }
              </mat-card-content>
            </mat-card>

            <!-- Age -->
            <mat-card class="tomass-chart-card">
              <mat-card-header class="tomass-chart-card__header">
                <mat-card-title>{{ i18n.chart.ageParticipation }}</mat-card-title>
                <mat-card-subtitle>{{ state.kpi.recordCount }}{{ i18n.kpi.unit.count }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                @if (state.status === 'loading') {
                  <div class="tomass-chart-loading" role="status" aria-live="polite" aria-busy="true">
                    <div class="tomass-skeleton tomass-chart-loading__visual"></div>
                    <div class="tomass-skeleton tomass-chart-loading__line tomass-chart-loading__line--lg"></div>
                    <div class="tomass-skeleton tomass-chart-loading__line"></div>
                    <span class="visually-hidden">Loading...</span>
                  </div>
                } @else if (state.kpi.recordCount > 0) {
                  <div class="tomass-chart-with-legend">
                    <div echarts [options]="state.ageChartOption" [autoResize]="true" class="tomass-chart tomass-chart--donut"></div>
                    <ul class="tomass-legend">
                      @for (item of visibleLegendItems(state.ageChartLegend, 'age'); track item.label) {
                        <li class="tomass-legend__item">
                          <span class="tomass-legend__dot" [style.background]="item.color"></span>
                          <span class="tomass-legend__label">{{ item.label }}</span>
                          <span class="tomass-legend__count">{{ item.count }}{{ i18n.kpi.unit.count }}</span>
                          <span class="tomass-legend__pct">({{ item.percentage }}%)</span>
                        </li>
                      }
                    </ul>
                    @if (hiddenLegendCount(state.ageChartLegend) > 0) {
                      <button class="tomass-legend__toggle" (click)="toggleLegend('age')">
                        @if (isLegendExpanded('age')) {
                          <mat-icon>expand_less</mat-icon><span i18n>閉じる</span>
                        } @else {
                          <mat-icon>expand_more</mat-icon><span i18n>他{{ hiddenLegendCount(state.ageChartLegend) }}件を表示</span>
                        }
                      </button>
                    }
                  </div>
                } @else {
                  <div class="tomass-chart-empty">{{ i18n.chart.noData }}</div>
                }
              </mat-card-content>
            </mat-card>

            <!-- Gender -->
            <mat-card class="tomass-chart-card">
              <mat-card-header class="tomass-chart-card__header">
                <mat-card-title>{{ i18n.chart.genderRatio }}</mat-card-title>
                <mat-card-subtitle>{{ state.kpi.recordCount }}{{ i18n.kpi.unit.count }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                @if (state.status === 'loading') {
                  <div class="tomass-chart-loading" role="status" aria-live="polite" aria-busy="true">
                    <div class="tomass-skeleton tomass-chart-loading__visual"></div>
                    <div class="tomass-skeleton tomass-chart-loading__line tomass-chart-loading__line--lg"></div>
                    <div class="tomass-skeleton tomass-chart-loading__line"></div>
                    <span class="visually-hidden">Loading...</span>
                  </div>
                } @else if (state.kpi.recordCount > 0) {
                  <div class="tomass-chart-with-legend">
                    <div echarts [options]="state.genderChartOption" [autoResize]="true" class="tomass-chart tomass-chart--donut"></div>
                    <ul class="tomass-legend">
                      @for (item of visibleLegendItems(state.genderChartLegend, 'gender'); track item.label) {
                        <li class="tomass-legend__item">
                          <span class="tomass-legend__dot" [style.background]="item.color"></span>
                          <span class="tomass-legend__label">{{ item.label }}</span>
                          <span class="tomass-legend__count">{{ item.count }}{{ i18n.kpi.unit.count }}</span>
                          <span class="tomass-legend__pct">({{ item.percentage }}%)</span>
                        </li>
                      }
                    </ul>
                    @if (hiddenLegendCount(state.genderChartLegend) > 0) {
                      <button class="tomass-legend__toggle" (click)="toggleLegend('gender')">
                        @if (isLegendExpanded('gender')) {
                          <mat-icon>expand_less</mat-icon><span i18n>閉じる</span>
                        } @else {
                          <mat-icon>expand_more</mat-icon><span i18n>他{{ hiddenLegendCount(state.genderChartLegend) }}件を表示</span>
                        }
                      </button>
                    }
                  </div>
                } @else {
                  <div class="tomass-chart-empty">{{ i18n.chart.noData }}</div>
                }
              </mat-card-content>
            </mat-card>
          </section>

          <section class="tomass-map-frequency-grid">
            <div class="tomass-map-frequency-grid__map" #mapSection>
              <mat-card class="tomass-chart-card">
                <mat-card-header class="tomass-chart-card__header">
                  <mat-card-title>{{ i18n.map.title }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  @if (state.status === 'loading') {
                    <div class="tomass-chart-loading" role="status" aria-live="polite" aria-busy="true">
                      <div class="tomass-skeleton tomass-chart-loading__visual tomass-chart-loading__visual--map"></div>
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  } @else {
                    <app-tomass-regional-map
                      [markers]="state.mapMarkers"
                      [selectedGeohashes]="selectedFrequencyGeohashes()"
                    ></app-tomass-regional-map>
                  }
                </mat-card-content>
              </mat-card>
            </div>

            <div class="tomass-map-frequency-grid__table">
              @if (state.status === 'loading') {
                <mat-card class="tomass-chart-card">
                  <mat-card-content>
                    <app-table-skeleton [rows]="8"></app-table-skeleton>
                  </mat-card-content>
                </mat-card>
              } @else {
                <app-tomass-frequency-table
                  [rows]="state.frequencyRows"
                  [selectedDateKey]="selectedFrequencyDateKey()"
                  (rowSelection)="onFrequencyRowSelection($event)"
                ></app-tomass-frequency-table>
              }
            </div>
          </section>

          <!-- Histogram -->
          <section class="tomass-histogram-grid">
            <mat-card class="tomass-chart-card">
              <mat-card-header class="tomass-chart-card__header">
                <mat-card-title>{{ i18n.chart.crackerHistogram }}</mat-card-title>
                <mat-card-subtitle>{{ i18n.chart.crackerHistogramSub }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                @if (state.status === 'loading') {
                  <div class="tomass-chart-loading" role="status" aria-live="polite" aria-busy="true">
                    <div class="tomass-skeleton tomass-chart-loading__visual tomass-chart-loading__visual--histogram"></div>
                    <div class="tomass-skeleton tomass-chart-loading__line tomass-chart-loading__line--lg"></div>
                    <span class="visually-hidden">Loading...</span>
                  </div>
                } @else if (state.kpi.recordCount > 0) {
                  <div echarts [options]="state.crackerHistogramOption" [autoResize]="true" class="tomass-chart tomass-chart--histogram"></div>
                } @else {
                  <div class="tomass-chart-empty">{{ i18n.chart.noData }}</div>
                }
              </mat-card-content>
            </mat-card>
          </section>

          <section class="tomass-frequency-table-print-section">
            @if (state.status === 'loading') {
              <mat-card class="tomass-chart-card">
                <mat-card-content>
                  <app-table-skeleton [rows]="8"></app-table-skeleton>
                </mat-card-content>
              </mat-card>
            } @else {
              <app-tomass-frequency-table
                [rows]="state.frequencyRows"
                [selectedDateKey]="selectedFrequencyDateKey()"
                (rowSelection)="onFrequencyRowSelection($event)"
              ></app-tomass-frequency-table>
            }
          </section>

        }
      </div>
    </div>
  }
</div>
